// @flow

export const adjustTimetoken = (timetoken: string, value: number): string =>
  // $FlowIgnoreMe
  String(BigInt(timetoken) + BigInt(value));
